import React, { useState, useRef, useId } from 'react';
import { flushSync } from 'react-dom';
import { txt } from './i18n/texts';
import { FeedbackThumbs } from './FeedbackThumbs';
import classNames from 'classnames';
import { FeedbackExpanded } from './FeedbackExpanded';
import { HighFive } from './HighFive';
export var Feedback = function (_a) {
    var _b;
    var _c;
    var _d = _a.headingLevel, headingLevel = _d === void 0 ? 4 : _d, _e = _a.locale, locale = _e === void 0 ? 'nb' : _e, onThumbClick = _a.onThumbClick, onFeedbackSend = _a.onFeedbackSend, bgColor = _a.bgColor, contactLink = _a.contactLink, texts = _a.texts, className = _a.className, _f = _a.includeConsent, includeConsent = _f === void 0 ? false : _f;
    var feedbackSentRef = useRef(null);
    var expandedRef = useRef(null);
    var _g = useState(false), expanded = _g[0], setExpanded = _g[1];
    var _h = useState(false), feedbackSent = _h[0], setFeedbackSent = _h[1];
    var headingId = useId();
    var feedbackClassnames = classNames('ffe-feedback', (_b = {},
        _b["ffe-feedback--bg-".concat(bgColor)] = bgColor,
        _b), className);
    var handleThumbClicked = function (thumb) {
        var _a;
        flushSync(function () {
            setExpanded(true);
        });
        (_a = expandedRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onThumbClick(thumb);
    };
    var handleFeedbackSent = function (feedbackText, consentGiven) {
        var _a;
        flushSync(function () {
            setFeedbackSent(true);
        });
        (_a = feedbackSentRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (feedbackText && feedbackText.length > 0) {
            onFeedbackSend(feedbackText, consentGiven);
        }
    };
    var renderHeading = function (level, text, options) {
        var _a;
        var _b = options || {}, ref = _b.ref, tabIndex = _b.tabIndex, id = _b.id, textCenter = _b.textCenter;
        var headingClassName = classNames("ffe-h".concat(level), (_a = {}, _a["ffe-h".concat(level, "--text-center")] = textCenter, _a), 'ffe-feedback__heading');
        return React.createElement("h".concat(level), {
            ref: ref,
            id: id,
            tabIndex: tabIndex,
            className: headingClassName,
        }, text);
    };
    if (feedbackSent) {
        return (React.createElement("div", { className: feedbackClassnames },
            React.createElement("div", { className: "ffe-feedback__content" },
                renderHeading(headingLevel, txt[locale].FEEDBACK_SENT_HEADING, { ref: feedbackSentRef, tabIndex: -1 }),
                React.createElement(HighFive, null))));
    }
    if (expanded) {
        return (React.createElement("div", { className: feedbackClassnames },
            React.createElement("div", { className: "ffe-feedback__expanded" },
                renderHeading(headingLevel, txt[locale].FEEDBACK_SENT_HEADING, { ref: expandedRef, tabIndex: -1 }),
                React.createElement(FeedbackExpanded, { locale: locale, handleFeedback: handleFeedbackSent, contactLink: contactLink, includeConsent: includeConsent }))));
    }
    return (React.createElement("div", { className: feedbackClassnames },
        React.createElement("div", { className: "ffe-feedback__content" },
            renderHeading(headingLevel, (_c = texts === null || texts === void 0 ? void 0 : texts.feedbackNotSentHeading) !== null && _c !== void 0 ? _c : txt[locale].FEEDBACK_NOT_SENT_HEADING, { id: headingId, textCenter: true }),
            React.createElement(FeedbackThumbs, { onClick: handleThumbClicked, locale: locale, headingId: headingId }))));
};
